export const TEXT = {
    TITLE: "Our Cookie Policy",
    ACCEPT_LABEL: "Accept & Continue",
    COOKIE_CONSENT_INFO: (link: string) =>
        `This website uses cookies to improve your online experience. By continuing to use this website, you agree to our use of cookies. If you would like to, you can change your cookie settings at any time. Our <a target="_blank" href="${link}">Privacy Policy for EU residents</a> provides more information about what cookies we use and how you can change them.`,
};

export const POP_UP_COOKIE_KEY = "show_pop";

export const POP_UP = {
    SHOW: "0",
    HIDE: "1",
};

export const CONSENT = {
    YES: "yes",
    NO: "no",
    EMPTY: "",
};
